import React from 'react';
import { Box, Stack, Typography, Alert } from '@mui/material';
import { PersonOutline, InfoOutlined } from '@mui/icons-material';
import { SectionHeader, SectionPaper } from '../../../../common/components';
import {
  AssignedToEdit,
  AssignedTeamEdit
} from '../fields';

interface AssignmentInformationSectionProps {
  showGuidance?: boolean;
}

/**
 * AssignmentInformationSection - Handles ticket assignment fields
 * Contains assigned user and team information with optional guidance
 */
export const AssignmentInformationSection: React.FC<AssignmentInformationSectionProps> = ({ 
  showGuidance = false 
}) => {
  return (
    <Box>
      <SectionHeader 
        icon={<PersonOutline sx={{ mr: 1, color: '#3b82f6', fontSize: 18 }} />} 
        title="Assignment Information" 
      />
      <SectionPaper>
        <Stack spacing={2}>
          {/* Helpful notice for users - only show on create */}
          {showGuidance && (
            <Alert 
              severity="info" 
              icon={<InfoOutlined fontSize="small" />}
              sx={{ 
                backgroundColor: '#f0f8ff',
                border: '1px solid #b3d9ff',
                '& .MuiAlert-message': {
                  fontSize: '0.875rem'
                }
              }}
            >
              <Typography variant="body2" color="text.secondary">
                Leave blank if unsure - we'll assign during triage.
              </Typography>
            </Alert>
          )}

          {/* Assignment fields */}
          <Stack direction="row" gap={2}>
            <AssignedToEdit />
            <AssignedTeamEdit />
          </Stack>
        </Stack>
      </SectionPaper>
    </Box>
  );
};

export default AssignmentInformationSection;
